import PropTypes from "prop-types"
import React from "react"
import Visibility from "../../visibility"

const ChartItem = (name, average, animate) => (
  <div className="col col-12 px1">
    <h5 className="fg-mercer-gray-mid bold">{name}</h5>
    <div className="col col-9 lg-col-10">
      <span className="col col-12 bg-white">
        <span
          className="col bg-mercer-blue-gradient white p1"
          style={{
            width: `${animate ? average : 0}%`,
            height: "20px",
            transition: "width 250ms ease-in-out",
          }}
        />
      </span>
    </div>
    <div className="col col-3 lg-col-2 px1 right-align">
      <small className="fg-mercer-gray-dark bold">{average.toFixed(0)}%</small>
    </div>
  </div>
)

const MiscBarometer = ({ block, values, animate }) => (
  <div
    className="flex flex-column col col-12 bg-mercer-glass-dark fg-mercer-gray-dark p1 md-p2 relative"
    style={{
      minHeight: "100%"
    }}
  >
    <div className="flex-auto col col-12">
      <Visibility>
        {({ isVisible }) => (
          <div style={{height: "260px"}}>
            <h4 className="fg-mercer-gray-dark center mt0 mb1 uppercase letter-space-1.5" style={{fontSize: "18px"}}>{block.title}</h4>
            {ChartItem("Contraction", values.contraction, isVisible && animate)}
            {ChartItem("Stable", values.stable, isVisible && animate)}
            {ChartItem("Expansion", values.expansion, isVisible && animate)}
          </div>
        )}
      </Visibility>
      <div className="col col-12 center mb2 line-height-1">
        <p className="fg-mercer-gray-dark">{block.content}</p>
      </div>
    </div>
    <div className="col col-12 center">
      <a href={block.link1} target="_parent" className="btn btn-primary bg-mercer-gray-light fg-mercer-gray-dark col col-12">Learn More ></a>
    </div>
  </div>
)

MiscBarometer.propTypes = {
  block: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
    link1: PropTypes.string,
  }),
  values: PropTypes.shape({
    contraction: PropTypes.number,
    stable: PropTypes.number,
    expansion: PropTypes.number,
  }),
  animate: PropTypes.bool,
}

MiscBarometer.defaultProps = {
  block: {
    title: ``,
    content: ``,
    link1: ``,
  },
  values: {
    contraction: 0,
    stable: 0,
    expansion: 0,
  },
  animate: true,
}

export default MiscBarometer
